export const CONSTANTS = {
  LOW_BATTERY_THRESHOLD: 15,
  LOW_VOLTAGE_THRESHOLD: 3000,
  END_OF_LIFE_REPORTING_THRESHOLD: 7 * 24 * 60 * 60 * 1000,
  LOW_BATTERY: 'lowBattery',
  LOW_VOLTAGE: 'lowVoltage',
  END_OF_LIFE: 'endOfLife'
};
const opts = {
  filterable: true,
  sortable: false
};
export default {
  id: 'locator.batteryAlerts',
  name: 'locator.batteryAlerts',
  displayName: 'Battery Alerts',
  valueType: 'string',
  objectType: 'locator',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const lastHeartbeat = obj?.data?.lastHeartbeat;
    if (lastHeartbeat != null) {
      const isEOL = Date.now() - CONSTANTS.END_OF_LIFE_REPORTING_THRESHOLD > lastHeartbeat;
      if (isEOL) {
        return CONSTANTS.END_OF_LIFE;
      }
    }
    const batteryVoltage = obj?.data?.batteryVoltage;
    if (batteryVoltage != null) {
      if (batteryVoltage <= CONSTANTS.LOW_VOLTAGE_THRESHOLD) {
        return CONSTANTS.LOW_VOLTAGE;
      }
    }
    const batteryLevel = obj?.data?.batteryLevel;
    if (batteryLevel != null) {
      if (batteryLevel <= CONSTANTS.LOW_BATTERY_THRESHOLD) {
        return CONSTANTS.LOW_BATTERY;
      }
    }
    return null;
  }
};